import TrinhLanhDaoTTXM from './chuyen-vien-nhap-lieu/TrinhLanhDaoTTXM.jsx';
import LanhDaoGiaoViecTTXM from './lanh-dao/LanhDaoGiaoViecTTXM.jsx';
import NhiemVuTTXM from './NhiemVuTTXM.jsx';
import NhapThongTinToTTXM from './chuyen-vien/NhapThongTinToTTXM.jsx';
import TrinhLanhDaoTTXMView from './chuyen-vien-nhap-lieu/TrinhLanhDaoTTXMView.jsx';
import LanhDaoGiaoViecTTXMView from './lanh-dao/LanhDaoGiaoViecTTXMView.jsx';
import NhapThongTinToTTXMView from './chuyen-vien/NhapThongTinToTTXMView.jsx';
import KetQuaHoanThanhGiaiQuyetDonCanBo from './chuyen-vien/KetQuaHoanThanhGiaiQuyetDonCanBo.jsx';
import KetQuaLapDuThaoCanBo from './chuyen-vien/KetQuaLapDuThaoCanBo.jsx';
import GiaiQuyetDonCanBo from './chuyen-vien/GiaiQuyetDonCanBo.jsx';
import CanBoGiaiQuyetYeuCauLapDuThao from './chuyen-vien/CanBoGiaiQuyetYeuCauLapDuThao.jsx';
import LapDuThaoDonKhieuNaiCanBo from './chuyen-vien/LapDuThaoDonKhieuNaiCanBo.jsx';
import LapDuThaoCanBo from './chuyen-vien/LapDuThaoCanBo.jsx';
import TrinhLanhDaoTheoDoiThucHien from './chuyen-vien-nhap-lieu/TrinhLanhDaoTheoDoiThucHien.jsx';
import TrinhLanhDaoTheoDoiThucHienView from './chuyen-vien-nhap-lieu/TrinhLanhDaoTheoDoiThucHienView.jsx';
import LanhDaoGiaoViecTheoDoiGiamSat from './lanh-dao/LanhDaoGiaoViecTheoDoiGiamSat.jsx';
import LanhDaoGiaoViecTheoDoiGiamSatView from './lanh-dao/LanhDaoGiaoViecTheoDoiGiamSatView.jsx';
import CanBoNhanYeuCauTheoDoiThucHien from './chuyen-vien/CanBoNhanYeuCauTheoDoiThucHien.jsx';

export {
  TrinhLanhDaoTTXM,
  LanhDaoGiaoViecTTXM,
  NhapThongTinToTTXM,
  NhiemVuTTXM,
  TrinhLanhDaoTTXMView,
  LanhDaoGiaoViecTTXMView,
  NhapThongTinToTTXMView,
  KetQuaHoanThanhGiaiQuyetDonCanBo,
  KetQuaLapDuThaoCanBo,
  LapDuThaoDonKhieuNaiCanBo,
  GiaiQuyetDonCanBo,
  LapDuThaoCanBo,
  CanBoGiaiQuyetYeuCauLapDuThao,
  TrinhLanhDaoTheoDoiThucHien,
  TrinhLanhDaoTheoDoiThucHienView,
  LanhDaoGiaoViecTheoDoiGiamSatView,
  LanhDaoGiaoViecTheoDoiGiamSat,
  CanBoNhanYeuCauTheoDoiThucHien
}


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-giai-quyet/index.js